import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { itemService } from '@/services/item';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export default function useItemSettingAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        timeUnit: 0,
        timeDuration: 0,
        startTime: new Date()
    });

    const validations = {
        timeDuration: { required, numeric, minValue: minValue(1), maxValue: maxValue(3200) },
        startTime: { required, validateDate: validateDateAfter() }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => itemService.setting.get(model.id),
        onSuccess: ({ data }) => {
            model.timeUnit = data.timeUnit;
            model.timeDuration = data.timeDuration;
            model.startTime = new Date(data.startTime);
        },
        onError: () => router.push({ name: ROUTE_NAME_ITEM.APP_SETTING.INDEX })
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            itemService.setting.update(model.id, model.timeUnit, model.timeDuration, model.startTime.getTime()),
        onSuccess: () => router.push({ name: ROUTE_NAME_ITEM.APP_SETTING.INDEX })
    });

    onMounted(() => fetch());

    return { model, v$, timeUnits, update };
}
